let modal = () => {
  document.addEventListener("DOMContentLoaded", () => {

    // Functions to open and close a modal
    function openModal($el) {
      $el.classList.add("is-active");

      if ($el.classList.contains("js-modal-youtube")) {
        let youTubeSrc = $el.dataset.src;
        $el.querySelector("iframe").setAttribute("src", youTubeSrc);
      }
    }

    function closeModal($el) {
      $el.classList.remove("is-active");

      if ($el.classList.contains("js-modal-youtube")) {
        $el.querySelector("iframe").removeAttribute("src");
      }
    }

    function closeAllModals() {
      (document.querySelectorAll(".modal") || []).forEach(($modal) => {
        closeModal($modal);
      });
    }

    // Add a click event on buttons to open a specific modal
    (document.querySelectorAll(".js-modal-trigger") || []).forEach(
      ($trigger) => {
        const modal = $trigger.dataset.target;
        const $target = document.getElementById(modal);

        $trigger.addEventListener("click", () => {
          openModal($target);
        });
      }
    );

    // Add a click event on various child elements to close the parent modal
    (
      document.querySelectorAll(
        ".modal-backdrop, .modal-close"
      ) || []
    ).forEach(($close) => {
      const $target = $close.closest(".modal");

      $close.addEventListener("click", () => {
        closeModal($target);
      });
    });

    // Add a keyboard event to close all modals
    document.addEventListener("keydown", (event) => {
      const e = event || window.event;

      if (e.keyCode === 27) {
        // Escape key
        closeAllModals();
      }
    });
  });
};

export { modal };
